<template>
    <div id="app" class="app-container">
        <router-view />
    </div>
</template>

<script lang="ts" src="./App.ts"></script>

<style lang="scss">
@import '@/assets/scss/style';
@import 'maplibre-gl/dist/maplibre-gl.css';
</style>
